import {Component, OnDestroy, OnInit} from '@angular/core';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {DialogModel} from '@shared/models/dialog.model';
import {CountryCalculatorDto} from '@features/global-tax-calculator/models/diagnostic-report.model';

@Component({
    standalone: false,
    selector: 'app-show-country-calculators-dialog',
  templateUrl: './show-country-calculators-dialog.component.html',
  styleUrl: './show-country-calculators-dialog.component.scss'
})
export class ShowCountryCalculatorsDialogComponent implements OnInit, IDialogView, OnDestroy {
  data: DialogModel;
  countryCalculators: Array<CountryCalculatorDto> = new Array<CountryCalculatorDto>();
  ngOnDestroy(): void {
  }

  ngOnInit(): void {
    this.countryCalculators = this.data.input.countryCalculators;
  }

  onOkClicked(): any {
    return true;
  }

}
